import React from "react";
import PropTypes from "prop-types";
import { X } from "lucide-react";
import './PromoCodes.scss';
import { useDispatch } from "react-redux";
import { removePromoCode } from "../../store/cartSlice";

const PromoCodes = ({ promoCodes }) => {
  const dispatch = useDispatch();

  if (promoCodes.length === 0) return null;

  return (
    <div className="flex gap-2 flex-wrap">
      {promoCodes.map((promo, i) => (
        <div
          key={promo.code}
          className="px-3 py-2 bg-secondary text-white rounded-20 text-base flex items-center gap-2 relative"
        >
          <span>
            {(promo.code).toUpperCase()}
            {promo.discount_amount ? ` (${promo.discount_type == 'fixed' ? '$' : ''}${promo.discount_amount}${promo.discount_type == 'percent' ? '%' : ''})` : ""}
            {(promo.discount_type == 'percent' && promo.max_order_total) ? <span className="max-discount-badge">MAX ${promo.max_order_total} OFF</span> : ''}

          </span>
          {!promo.is_affiliate &&
            <X
              size={15}
              className="cursor-pointer"
              onClick={() => dispatch(removePromoCode(promo.code))}
            />
          }
        </div>
      ))}
    </div>
  );
};

PromoCodes.propTypes = {
  promoCodes: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired,
    discount_amount: PropTypes.number,
    discount_type: PropTypes.string,
    is_affiliate: PropTypes.bool
  })).isRequired
};

export default PromoCodes;
